import React from 'react'
import Modal from 'components/Modal'
import Close from 'components/Close'
import { Mutation } from 'react-apollo'
import { ADD_API_KEY, GET_API_KEYS } from 'operations/Auth'
import { Fieldset, Input, Submit } from 'components/Form'

export default class AddApiKey extends React.Component {

    constructor(props) {
        super(props)
        this.state = {
            name: '',
            scopes: [],
            key: ''
        }

        this.handleChange = this.handleChange.bind(this)
        this.handleClose = this.handleClose.bind(this)

        this.textarea = React.createRef()
        this.handleCopy = this.handleCopy.bind(this)
    }

    handleClose(e) {
        if (this.props.onClose) {
            this.props.onClose(e)
        }
    }

    handleChange = ({ target: { name, value } }) => {
        this.setState({
            [name]: value
        })
    }

    handleCopy = () => {
        this.textarea.current.select()
        document.execCommand('copy')
    }

    render() {

        return(
            <Modal>
                
                <Close onClick={ this.handleClose } />
                <div className='modal__form'>

                    {
                        this.state.key ? (
                            <React.Fragment>

                                <h1>Great!</h1>
                                <h2>Your API key has been added</h2>
                                <textarea ref={this.textarea} value={ this.state.key } />
                                Please copy your API key now. For your security, it will not be displayed again.
                                <button onClick={ this.handleCopy }>Copy to clipboard</button>

                            </React.Fragment>
                        ) : (
                            <React.Fragment>

                                <h1>Let's add an API key</h1>

                                <Mutation mutation={ ADD_API_KEY } refetchQueries={[{ query: GET_API_KEYS}]} fetchPolicy='no-cache' >
                                    {( addApiKey ) => (
                                        <form onSubmit={(e) => {
                                            e.preventDefault()

                                            addApiKey({
                                                variables: {
                                                    data: {
                                                        name: this.state.name,
                                                        scopes: [
                                                            {
                                                                scope: 'ALL',
                                                                actions: ['READ', 'WRITE']
                                                            }
                                                        ]
                                                    }
                                                }
                                            })
                                            .then(({data: { addApiKey: { key } }}) => {
                                                this.setState({
                                                    name: '',
                                                    key
                                                })
                                                // this.handleClose()
                                            })
                                            .catch(err => {
                                                console.log(err)
                                            })
                                            
                                        }}>
                                            <Fieldset legend='API Key'>
                                                <Input name='name' label='API key name' helper='Alphanumeric' value={ this.state.name } onChange={ this.handleChange } autocomplete='off' />
                    
                                                <Submit value='Add API key'/>
                                            </Fieldset>
                                        </form>    
                                    )}
                                </Mutation>

                            </React.Fragment>
                        )
                    }

                </div>
            </Modal>
        )

    }

}


// WEBPACK FOOTER //
// ./src/components/AddApiKey/index.js